<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body px-3 pt-0 pb-2 min-vh-50">
              <form id="search" class="mt-3" @submit.prevent="getPO">
                <div class="row g-2 d-flex justify-content-end">
                  <div class="col-12 col-sm">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">PO Number</label>
                    <div class="input-group input-group-sm">
                      <span class="input-group-text" id="basic-addon1">
                        <i class="fa fa-search"></i>
                      </span>
                      <input 
                        v-model="search.po_number" 
                        type="text" 
                        class="form-control" 
                        placeholder="PO Number" 
                        aria-label="PO Number" 
                        aria-describedby="basic-addon1">
                    </div>
                  </div>
                  <div class="col-12 col-sm-3">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">PO Date</label>
                    <Datepicker 
                      v-model="search.po_date" 
                      range
                      format="dd MMM yyyy"/>
                  </div>
                  <div class="col-12 col-sm-3">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">Confirmation Date</label>
                    <Datepicker 
                      v-model="search.date_approve" 
                      range
                      format="dd/MM/yyyy"/>
                  </div>
                  <div class="col-12 col-sm-3">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">Expected Arrival</label>
                    <Datepicker 
                      v-model="search.date_planned" 
                      range
                      format="dd/MM/yyyy"/>
                  </div>
                  <div class="col-12 col-sm-1 align-self-end">
                    <button type="submit" class="btn btn-sm btn-primary mb-0">
                      <i class="fa fa-search"></i>
                    </button>
                  </div>
                </div>
              </form>
              <hr class="my-2"/>
              <div class="d-flex justify-content-end">
                <p class="align-self-center text-xs text-secondary">{{ current_page }} - {{ current_total_data }} / {{ total_data }}</p>
                <argon-pagination color="gradient-primary" size="sm">
                  <argon-pagination-item
                  @click="prevPage"
                    prev
                    :disabled="offset === 0 ? true : false" />
                  <argon-pagination-item
                    @click="nextPage"
                    next
                    :disabled="record_more === false ? true : false" />
                </argon-pagination>
              </div>
              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr class="bg-light">
                      <th class="text-uppercase text-xxs fw-bolder">Reference</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Order Date</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Expected Arrival</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Type of Procurement</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Status</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="po in po_list" :key="po.purchase_id">
                      <td>
                          <router-link :to="'/purchase-order/' + po.purchase_id" class="text-xs text-primary fw-bold mb-0 ps-3">
                            {{ po.name }}
                          </router-link>
                      </td>
                      <td>
                        <p class="text-xs mb-0">{{ po.date_order }}</p>
                      </td>
                      <td>
                        <p class="text-xs mb-0">{{ po.date_planned }}</p>
                      </td>
                      <td>
                        <p class="text-xs mb-0">{{ po.type_of_procurement }}</p>
                      </td>
                      <td class="align-middle text-sm">
                        <span :class="'badge badge-sm ' + (po.over_deadline ? 'bg-warning' : 'bg-primary')">{{ po.state }}</span>
                      </td>
                      <td class="align-middle">
                        <span class="text-secondary text-xs">{{ po.amount_total }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <empty-state v-if="!po_list.length > 0 && !loading"/>
              <loading-state v-if="loading == true"/>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import ArgonPagination from "@/components/ArgonPagination.vue";
import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
import EmptyState from "./components/EmptyState.vue";
import LoadingState from "./components/LoadingState.vue";
// import ArgonInput from "@/components/ArgonInput.vue";
const endpoint = require("../router/endpoint");

export default {
  name: "purchase-order",
  components: {
    ArgonPagination,
    ArgonPaginationItem,
    EmptyState,
    LoadingState
    // ArgonInput
  },
  data() {
    return {
      search: {
          po_number: null,
          po_date: [],
          date_planned: [],
          date_approve: [],
      },
      po_list: [],
      loading: false,
      total_data: 0,
      current_total_data: 0,
      current_page: 0,
      record_more: false,
      offset: 0,
    };
  },
  methods: {
    prevPage() {
      if (this.offset > 0) {
          this.offset = this.offset - 10
          this.getPO()
        }
    },
    nextPage() {
      if (this.record_more === true) {
        this.offset = this.offset + 10
        this.getPO()
      }
    },
    getDate(daterange) {
      var dateList = []
      if (daterange !== null){
        if (daterange.length > 0) {
          daterange.forEach(date => {
            if (date) {
              let month = date.getMonth() >= 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
              let fullDate = date.getFullYear() + '-' + month + '-' + date.getDate()
              dateList.push(fullDate)
            }
          });
        }
      }
      return dateList
    },
    getPO() {
      this.po_list = []
      this.loading = true
      this.total_data = 0
      this.current_total_data = 0
      this.record_more = false
      this.current_page = 0
      const po_daterange = this.getDate(this.search.po_date)
      const date_plannedrange = this.getDate(this.search.date_planned)
      const date_approverange = this.getDate(this.search.date_approve)
      let offset = 0
      if (po_daterange.length > 0 || date_plannedrange.length > 0 || date_approverange.length > 0 || this.search.po_number) {
        offset = 0
      } else {
        offset = this.offset
      }
      this.axios
        .post(
          endpoint.PO_LIST,
          {
            partner_id: parseInt(localStorage.getItem("partner_id")),
            name: this.search.po_number || '',
            date_from: po_daterange.length > 0 ? po_daterange[0] : '',
            date_to: po_daterange.length > 1 ? po_daterange[1] : '',
            date_planned_from: date_plannedrange.length > 0 ? date_plannedrange[0] : '',
            date_planned_to: date_plannedrange.length > 1 ? date_plannedrange[1] : '',
            date_approve_from: date_approverange.length > 0 ? date_approverange[0] : '',
            date_approve_to: date_approverange.length > 1 ? date_approverange[1] : '',
            limit: 10,
            offset: offset
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.msg_status === "0002"){
                    this.$notify({
                        type: 'warn',
                        title: 'Expired',
                        text: 'Session expired, please sign in again.',
                    });
                    this.$router.replace('/signin')
                    return false
          } else if (response.data.response_code === "0000") {
            this.po_list = response.data.data;
            this.total_data = response.data.total_data
            this.current_total_data = response.data.current_total_data
            this.record_more = response.data.record_more
            this.current_page = response.data.current_page
          } else {
            if (response.data.response_code !== "4000"){
              this.$notify({
                type: 'error',
                title: 'Warning',
                text: response.data.message,
              });
            }
          }
          this.loading = false
        })
        .catch((e) => {
          this.$notify({
            type: 'error',
            title: 'Error',
            text: e.response.data.message || e,
          });
          this.loading = false
        });
    }
  },
  mounted() {
    this.getPO();
  }
};
</script>

<style>

</style>